import { jsxs as u, jsx as l } from "react/jsx-runtime";
import { Form as r, Input as i } from "antd";
import { useState as m, useEffect as f } from "react";
const { Item: p } = r, x = (a) => {
  const { name: t } = a, o = r.useFormInstance(), [c, s] = m(""), e = r.useWatch(t, o);
  if (f(() => {
    e && s(e == null ? void 0 : e.id);
  }, [e]), !t)
    throw new Error("name is required");
  const d = (n) => {
    s(n.target.value), o.setFieldValue(t, {
      type: "code",
      id: n.target.value,
      meta: {}
    });
  };
  return /* @__PURE__ */ u("div", { className: "at-relative", children: [
    /* @__PURE__ */ l(
      i.TextArea,
      {
        allowClear: !0,
        className: "at-mb-1 at-rounded-lg",
        rows: 12,
        onChange: d,
        value: c,
        placeholder: "你可以放任何你想放的 HTML 或 iframe 或 Javascript 嵌入代碼，例如 JWP 影片、prestoplayer/WordPress shortcode 等..."
      }
    ),
    /* @__PURE__ */ l(p, { ...a, hidden: !0 })
  ] });
};
export {
  x as default
};
